<template>
    <div>
        <bestellstrecke-header>
            <template v-slot:title><h1 class="headline" v-html="tabHeader" /></template>
            <div v-html="tabIntroText"></div>
        </bestellstrecke-header>


        <!-- START: section-content -->
        <section class="section section-content section-tariff-form">


            <!-- START form-body -->
            <div class="form-body tariff-form">

                <div class="container">

                    <div class="row">
                        <div class="col-lg-6">

                            <!-- START form-tabs -->
                            <div class="form-tabs">
                                <div class="tab-nav">
                                    <ul class="nav nav-tabs" role="tablist">
                                        <li class="nav-item" :class="{disabled: !isTabEnabled(0)}">
                                            <a href="#"
                                               class="nav-link"
                                               :class="{active: activeTab === 0, disabled: !isTabEnabled(0)}"
                                               role="tab"
                                               @click.prevent="isTabEnabled(0) && showTab(0)">
                                                <span class="img">1</span>
                                                <span class="txt">Adressen</span>
                                            </a>
                                        </li>
                                        <li class="nav-item" :class="{disabled: !isTabEnabled(1)}">
                                            <a href="#"
                                               class="nav-link"
                                               :class="{active: activeTab === 1, disabled: !isTabEnabled(1)}"
                                               role="tab"
                                               @click.prevent="isTabEnabled(1) && showTab(1)">
                                                <span class="img">2</span>
                                                <span class="txt">Lieferung und Zahlung</span>
                                            </a>
                                        </li>
                                        <li class="nav-item" :class="{disabled: !isTabEnabled(2)}">
                                            <a href="#"
                                               class="nav-link disabled"
                                               :class="{active: activeTab === 2, disabled: !isTabEnabled(2)}"
                                               role="tab"
                                               @click.prevent="isTabEnabled(2) && showTab(2)">
                                                <span class="img">3</span>
                                                <span class="txt">Prüfen und Bestellen</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <!-- END form-tabs -->

                            <bestellstrecke-form-adressen v-if="activeTab === 0"
                                                          :formData="formData"
                                                          @next="next"
                                                          @prev="prev"
                                                          @changeTab="showTab" />
                            <bestellstrecke-form-lieferung v-if="activeTab === 1"
                                                           :formData="formData"
                                                           @next="next"
                                                           @prev="prev"
                                                           @changeTab="showTab" />
                            <bestellstrecke-form-zusammenfassung v-if="activeTab === 2"
                                                                 :formData="formData"
                                                                 :error-message="errorMessage"
                                                                 :loading="loading"
                                                                 @next="next"
                                                                 @prev="prev"
                                                                 @handleJvlClick="handleJvlClick"
                                                                 :jvl="jvl"
                                                                 @changeTab="showTab" />

                        </div>
                        <div class="col-lg-4">
                            <bestellstrecke-tarifkarte :formData="formData" @renderPopover="renderPopover" @setFValue="setFValue" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import axios from 'axios';
import BestellstreckeHeader from "@/components/Bestellstrecke/BestellstreckeHeader";
import BestellstreckeTarifkarte from "@/components/Bestellstrecke/BestellstreckeTarifkarte";
import BestellstreckeFormAdressen from "@/components/Bestellstrecke/BestellstreckeFormAdressen";
import BestellstreckeFormLieferung from "@/components/Bestellstrecke/BestellstreckeFormLieferung";
import BestellstreckeFormZusammenfassung from "@/components/Bestellstrecke/BestellstreckeFormZusammenfassung";
import Form from "@/mixins/Form";
import {getTarife} from "@/service/getTarife";
import {validateGutscheinCode} from "@/service/validateGutscheinCode";

export default {
    name: 'Bestellstrecke',
    mixins: [Form],
    inject: ['settings'],
    provide() {
        return {
            gutschein: this.gutschein,
            setGutschein: this.setGutschein,
            resetGutschein: () => this.setGutschein({
                uid: 0,
                art: '',
                wert: '',
                wert_einheit: '',
                bezugspreis: '',
            }),
        }
    },
    components: {
        BestellstreckeFormZusammenfassung,
        BestellstreckeFormLieferung, BestellstreckeFormAdressen, BestellstreckeTarifkarte, BestellstreckeHeader
    },
    data: () => ({
        activeTab: 0,
        errorMessage: null,
        loading: false,
        jvl: 0,
        gutschein: {
            uid: 0,
            art: '',
            wert: '',
            wert_einheit: '',
            bezugspreis: '',
        },
    }),
    computed: {
        formData: function () {
            return this.collectFormData();
        },
        tabHeader: function () {
            switch (this.activeTab) {
                case 0: return this.settings.tab1Header.replace(/\|/g, '&shy;');
                case 1: return this.settings.tab2Header.replace(/\|/g, '&shy;');
                case 2: return this.settings.tab3Header.replace(/\|/g, '&shy;');
            }
            return '';
        },
        tabIntroText: function() {
            switch (this.activeTab) {
                case 0: return this.settings.tab1IntroText;
                case 1: return this.settings.tab2IntroText;
                case 2: return this.settings.tab3IntroText;
            }
            return '';
        },
    },
    mounted() {
        // Standardwerte vorgeben
        this.setValue('kunde_meldetyp', 'einzug');
        this.setValue('rechnung_typ', 'SEPA');

        // Adresse aus Preisrechner übernehmen
        // this.setValue('lieferadresse_plz', this.settings.preisrechner.adresse.plz || '');
        // this.setValue('lieferadresse_ort', this.settings.preisrechner.adresse.ort || '');
        this.setValue('lieferadresse_plz', this.settings.preisrechner.adresse.plzAndCity.plz || '');
        this.setValue('lieferadresse_ort', this.settings.preisrechner.adresse.plzAndCity.stadt || '');
        this.setValue('lieferadresse_strasse', this.settings.preisrechner.adresse.strasse || '');
        this.setValue('lieferadresse_hausnummer', this.settings.preisrechner.adresse.hnr || '');
        this.setValue('lieferadresse_hausnummer_zusatz', this.settings.preisrechner.adresse.hnrzusatz || '');
        this.setValue('lieferadresse_codenummer', this.settings.preisrechner.adresse.codenummer || '');

        // Tarif & Preis(-details) aus Preisrechner übernehmen
        this.setValue('tarif_id', this.settings?.preisrechner?.tarif?.id || '');
        this.setValue('tarif_typ', this.settings?.preisrechner?.tarif?.typ || '');
        this.setValue('tarif_commodity', this.settings?.tarif?.commodity || '');
        this.setValue('tarif_verbrauch', this.settings?.preisrechner?.verbrauch || '');
        this.setValue('tarif_preis_id', this.settings?.preisrechner?.tarif?.preis_id || 0);
        this.setValue('tarif_preis', this.settings?.preisrechner?.tarif?.preis || '');

        // Preisoptionen aus Preisrechner übernehmen
        this.setValue('preisoptionen', this.settings.preisrechner.tarif.preisoptionen);
        this.setValue('jvl', this.settings.preisrechner.jvl);
        this.setValue('jvl_auswaehlbar', this.settings.tarif.jvl);

        // Grundversorger übernehmen
        this.setValue('grundversorger', this.settings.preisrechner.grundversorger);

        // Standorteigenschaften übernehmen
        this.setValue('standorteigenschaften', this.settings.preisrechner.standorteigenschaften);

        // Formular vorausfüllen (Angebotsdaten übernehmen)
        if (this.settings.preisrechner.prefill) {
            Object.keys(this.settings.preisrechner.prefill).forEach(field => {
                if (field === 'angebot') return;
                let value = this.settings.preisrechner.prefill[field]
                if (field === 'tarif_commodity') {
                    if (value === 'strom') value = 1
                    else if (value === 'gas') value = 2
                }
                console.debug('prefill', field, value)
                this.setValue(field, value)
            })
        }

        // Angebot übernehmen
        if (this.settings.preisrechner.angebot) {
            this.setValue('angebot', this.settings.preisrechner.angebot || '')
        }

        // Gutscheincode anwenden
        if (this.getValue('gutschein_code')) {
            validateGutscheinCode(
                this.settings.gutscheinUrl,
                this.getValue('gutschein_code'),
                this.getValue('lieferadresse_plz'),
                this.getValue('tarif_id'),
                this.getValue('tarif_verbrauch')
            ).then(res => {
                if (res.success){
                    this.setGutschein(res.gutschein)
                    this.setFValue('gutschein', res.code)
                }
            })
        }

        console.debug('Bestellstrecke', this.settings);
    },
    methods: {
        next() {
            const valid = this.validateActiveFields();
            if (valid || this.settings.debug) {
                if (this.activeTab < 2) {
                    this.activeTab++;
                } else if (this.activeTab === 2) {
                    this.submit();
                }

                if (this.settings.debug) {
                    console.debug('activeFields are not valid', valid)
                    console.debug('debug-Mode // navigating regardless of validation errors')
                }

            } else {
                // show error message
                console.debug('activeFields are not valid', valid)
            }
            this.$el.scrollIntoView({behavior: 'smooth'});
        },
        prev() {
            if (this.activeTab > 0) {
                this.activeTab--;
                this.$el.scrollIntoView({behavior: 'smooth'});
            } else if ( this.activeTab === 0 && this.settings.preisrechnerUrl) {
                window.location.href = this.settings.preisrechnerUrl;
            }
        },
        showTab(index, anchor) {
            if (!this.isTabEnabled(index)) return;
            if (this.activeTab === index - 1) {
                this.next();
            } else if(this.activeTab > index) {
                this.activeTab = index
                if (typeof anchor !== 'undefined') {
                    this.$nextTick(() => {
                        setTimeout(() => {
                            const anchorEl = document.querySelector(anchor);
                            if (anchorEl) anchorEl.scrollIntoView({behavior: 'smooth', block: 'center'});
                        }, 100)
                    })
                }
            } else if (this.settings.debug) {
                this.activeTab = index;
                this.$el.scrollIntoView({behavior: 'smooth'});
            }
        },
        submit() {
            if (this.loading) return;
            this.errorMessage = null;
            this.loading = true;

            axios.post(this.settings.orderUrl, {
                formData: this.formData
            }).then(response => {
                console.log('okay', response.data);
                if (!response.data.success) {
                    this.errorMessage = response.data.errorMsg || 'Es ist ein unbekannter Fehler aufgetreten. Bitte prüfen Sie Ihre Eingaben und versuchen es erneut. Bitte prüfen Sie Ihre Eingaben und versuchen es erneut. Sollte der Fehler weiterhin bestehen kontaktieren Sie bitte unseren Support.';
                }
                if (response.data.redirect && !this.settings.debug) {
                    window.location.href = response.data.redirect;
                } else {
                    this.loading = false;
                }
            }).catch(() => {
                this.loading = false;
                this.errorMessage = 'Es ist ein unbekannter Fehler aufgetreten. Bitte prüfen Sie Ihre Eingaben und versuchen es erneut. Sollte der Fehler weiterhin bestehen kontaktieren Sie bitte unseren Support.';
            })
        },
        renderPopover: function(timeout = 1000){
            setTimeout(function(){
                window.$('[data-toggle="popover"]').popover();
            }, timeout);
        },
        setFValue: function(field, value){
            // this.formData[field] = value;
            this.setValue(field, value);
        },
        setGutschein: async function (gutschein) {
            // Preisberechnung erneut durchführen
            const data = await getTarife(
                this.settings.tarifUrl,
                this.formData.tarif_typ,
                this.formData.lieferadresse_plz + ', ' + this.formData.lieferadresse_ort,
                this.formData.lieferadresse_codenummer,
                this.formData.tarif_verbrauch,
                this.formData.tarif_id,
                1,
                gutschein.uid || null
            );
            this.setFValue('tarif_preis', data[0].preis);
            this.setFValue('tarif_preis_id', data[0].preis_id);

            // set this.gutschein (safe for reactivity)
            Object.keys(gutschein).forEach(key => this.$set(this.gutschein, key, gutschein[key]))
        },
        isTabEnabled(index) {
            // Nur Tabs bis zum aktuellen activeTab sind aktiv
            return index <= this.activeTab;
        },
    },
    watch: {
        'formData.preisoptionen': function() {

            // Leerzeichen in Zählernummer ersetzen
            this.setValue('kunde_zaehlernummer', this.formData.kunde_zaehlernummer?.replace(' ', ''));

            // Vorlieferant bereits gekündigt darf nicht ausgefüllt sein, wenn ein Tarifwechsel vorliegt
            if (this.formData.kunde_meldetyp == 'wechsel' && this.formData.kunde_bestandskunde) {
                this.setValue('kunde_vorversorger_gekuendigt', '');
                this.setValue('kunde_vorversorger_vertragsende', '');
                this.setValue('kunde_vorversorger', '');
                this.setValue('kunde_vorversorger_kundennummer', '');
            }

            // Kundennumer leeren wenn kein Bestandskunde
            if (!this.formData.kunde_bestandskunde) {
                this.setValue('kunde_kundennummer', '');
            }

            // Vorlieferant bereits gekündigt darf nicht ausgefüllt sein, wenn eine neue Verbrauchsstelle anmelden vorliegt
            if (this.formData.kunde_meldetyp == 'einzug') {
                this.setValue('kunde_vorversorger_gekuendigt', '');
                this.setValue('kunde_vorversorger_vertragsende', '');
                this.setValue('kunde_vorversorger', '');
                this.setValue('kunde_vorversorger_kundennummer', '');
            }
        }
    }
}
</script>
